// Popover "Som das notificações" (mockup Aeros): volume em %, testar o toque,
// notificações do navegador e "Silenciar até HH:MM" (localStorage
// notificationsMutedUntil — o NotificationsPopOver respeita).
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Slider from "@material-ui/core/Slider";
import Switch from "@material-ui/core/Switch";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import MusicNoteIcon from "@material-ui/icons/MusicNote";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import useSound from "use-sound";
import alertSound from "../../assets/sound.mp3";
import useHeaderStyles from "../../layout/header/headerStyles";
import useAerosSettingsStyles from "../Settings/aerosSettingsStyles";
import { AEROS } from "../../styles/aerosTokens";
import { muteUntil, isMuted } from "../../layout/header/headerRules";
import { i18n } from "../../translate/i18n";

export const MUTE_KEY = "notificationsMutedUntil";

const useStyles = makeStyles((theme) => ({
  slider: { flex: 1, color: AEROS.cyan, "& .MuiSlider-rail": { height: 6, borderRadius: 99, opacity: 1, backgroundColor: "rgba(128,128,128,0.25)" }, "& .MuiSlider-track": { height: 6, borderRadius: 99, background: "linear-gradient(90deg,#A044FF,#22D3EE)", border: "none" }, "& .MuiSlider-thumb": { width: 16, height: 16, marginTop: -5, backgroundColor: "#F1F2F6", boxShadow: "0 2px 6px rgba(0,0,0,0.5)" } },
  pct: { fontSize: 12, fontWeight: 700, fontVariantNumeric: "tabular-nums", width: 34, textAlign: "right", color: theme.palette.text.primary },
  time: { background: "none", border: `1px solid rgba(128,128,128,0.35)`, borderRadius: 8, padding: "3px 8px", font: "inherit", fontSize: 12, color: theme.palette.text.primary, colorScheme: theme.palette.type },
}));

// Conteúdo do popover, reutilizado no modal de Preferências.
export const SoundPanel = ({ volume, setVolume }) => {
  const h = useHeaderStyles();
  const aeros = useAerosSettingsStyles();
  const classes = useStyles();
  const [play] = useSound(alertSound, { volume: Number(volume) });
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "denied");
  const [mutedUntil, setMutedUntil] = useState(() => localStorage.getItem(MUTE_KEY) || "");
  const [muteTime, setMuteTime] = useState("14:00");
  const muted = isMuted(mutedUntil);

  useEffect(() => { if (mutedUntil && !isMuted(mutedUntil)) { localStorage.removeItem(MUTE_KEY); setMutedUntil(""); } }, [mutedUntil]);

  const toggleMute = (on) => {
    if (on) { const d = muteUntil(muteTime); if (!d) return; localStorage.setItem(MUTE_KEY, d.toISOString()); setMutedUntil(d.toISOString()); }
    else { localStorage.removeItem(MUTE_KEY); setMutedUntil(""); }
  };
  const toggleBrowser = async (on) => {
    if (!("Notification" in window)) return;
    if (on && Notification.permission !== "granted") { await Notification.requestPermission(); localStorage.removeItem("browserNotificationsOff"); }
    else if (on) localStorage.removeItem("browserNotificationsOff");
    else localStorage.setItem("browserNotificationsOff", "1");
    setPerm(Notification.permission);
  };
  const browserOn = perm === "granted" && !localStorage.getItem("browserNotificationsOff");
  const pct = Math.round(Number(volume) * 100);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <VolumeDownIcon style={{ fontSize: 18, opacity: 0.7 }} />
        <Slider className={classes.slider} value={Number(volume)} step={0.05} min={0} max={1} onChange={(_, v) => { setVolume(v); localStorage.setItem("volume", v); }} aria-label={i18n.t("aeros.header.volume")} />
        <span className={classes.pct}>{pct}%</span>
      </div>
      <div className={h.box}>
        <MusicNoteIcon style={{ color: AEROS.cyan }} />
        <div style={{ flex: 1 }}><div className={h.boxTitle}>{i18n.t("aeros.header.ringtone")}</div><div className={h.boxSub}>{i18n.t("aeros.header.clickToTest")}</div></div>
        <IconButton size="small" onClick={() => play()} aria-label={i18n.t("aeros.header.testRingtone")}><PlayCircleOutlineIcon style={{ fontSize: 18 }} /></IconButton>
      </div>
      <div className={h.toggleRow}>
        <div>{i18n.t("aeros.header.browserNotifications")}{perm === "denied" && <div className={h.boxSub}>{i18n.t("aeros.header.blockedInBrowser")}</div>}</div>
        <Switch className={aeros.toggleSwitchSmall} checked={browserOn} disabled={perm === "denied"} onChange={(e) => toggleBrowser(e.target.checked)} inputProps={{ "aria-label": i18n.t("aeros.header.browserNotifications") }} />
      </div>
      <div className={h.toggleRow}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>{i18n.t("aeros.header.muteUntil")} <input type="time" className={classes.time} value={muted ? new Date(mutedUntil).toTimeString().slice(0, 5) : muteTime} disabled={muted} onChange={(e) => setMuteTime(e.target.value)} aria-label={i18n.t("aeros.header.muteUntil")} /></div>
        <Switch className={aeros.toggleSwitchSmall} checked={muted} onChange={(e) => toggleMute(e.target.checked)} inputProps={{ "aria-label": i18n.t("aeros.header.mute") }} />
      </div>
    </>
  );
};

const NotificationsVolume = ({ volume, setVolume }) => {
  const h = useHeaderStyles();
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const mutedUntil = localStorage.getItem(MUTE_KEY) || "";
  const muted = isMuted(mutedUntil);
  const pct = Math.round(Number(volume) * 100);
  const Icon = muted || pct === 0 ? VolumeOffIcon : VolumeUpIcon;

  return (
    <>
      <Tooltip title={muted ? i18n.t("aeros.header.mutedUntil", { time: new Date(mutedUntil).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) }) : i18n.t("aeros.header.sound")}>
        <IconButton className={`${h.iconBtn} ${open ? h.iconBtnOn : ""}`} onClick={(e) => setAnchor(e.currentTarget)} aria-label={i18n.t("aeros.header.sound")}><Icon /></IconButton>
      </Tooltip>
      <Popover disableScrollLock open={open} anchorEl={anchor} onClose={() => setAnchor(null)} classes={{ paper: h.paper }} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <div className={h.pad14} style={{ width: 300 }}>
          <SoundPanel volume={volume} setVolume={setVolume} />
        </div>
      </Popover>
    </>
  );
};

export default NotificationsVolume;
